import { Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import chart from "../../../../assets/chart.png";
import graph from "../../../../assets/graph.png";
import purchase from "../../../../assets/purchase.png";
import twohands from "../../../../assets/twohands.png";
import npsscore from "../../../../assets/npsscore.png";
import error from "../../../../assets/error.png";
import PercentIcon from "@mui/icons-material/Percent";
import { useAppSelector } from "../../../../hooks/hooks";

import { GetArray, GetObject, WithCommas } from "../../../../utils/utils";

import MiniSpinner from "../../../reusableComponents/miniSpinner/miniSpinner";
import SectionCard from "../../../reusableComponents/sectionCard/sectionCard";
import StatTile from "../../../reusableComponents/statTile/statTile";
import { tokens } from "../../../../theme";
const AnalyticDashboard = (props: any) => {
  const { handleNavigation } = props;
  const {
    forecastData,
    revinvData,
    selectedBranch,
    selectedDepartment,
    purchaseTagRawData,
    purchaseFreqRawData,
    wsr12RawData,
    atRiskData,
    leadRawData,
    lostRawData,
    gainRawData,
    benchRawData,
    sseRawData,
    sseSumRawData,
    activeAccountLoading,
    purchaseDistributionLoading,
    retentionRateLoading,
    npsScoreLoading,
    atRiskLoading,
    retentionLoading,
    emailReportsLoading,
    marketCustRawData,
  } = useAppSelector((state: any) => state.portalManagement);

  const [dashboardActiveAccount, setDashboardActiveAccount] = useState("");
  const [dashboardGrowthAccount, setDashboardGrowthAccount] = useState("");
  const [dashboardForecastActiveAccount, setDashboardForecastActiveAccount] =
    useState("");
  const [dashboardForecastGrowthAccount, setDashboardForecastGrowthAccount] =
    useState("");
  const [
    dashboardTransactionInvoiceActive,
    setDashboardTransactionInvoiceActive,
  ] = useState("");
  const [
    dashboardTransactionInvoiceGrowth,
    setDashboardTransactionInvoiceGrowth,
  ] = useState("");
  const [dashboardForecastInvoiceActive, setDashboardForecastInvoiceActive] =
    useState("");
  const [dashboardForecastInvoiceGrowth, setDashboardForecastInvoiceGrowth] =
    useState("");

  const [dashboardRevenueActiveAccount, setDashboardRevenueActiveAccount] =
    useState("");
  const [dashboardRevenueAccountGrowth, setDashboardRevenueAccountGrowth] =
    useState("");
  const [dashboardForecastRevenue, setDashboardForecastRevenue] = useState("");
  const [dashboardForecastRevenueGrowth, setDashboardForecastRevenueGrowth] =
    useState("");

  const [dashboardCustomerPurchase, setDashboardCustomerPurchase] =
    useState("");
  const [dashboardCustomerFrquency, setDashboardCustomerFrquency] =
    useState("");
  const [dashboardRetentionRate, setDashboardRetentionRate] = useState("");
  const [dashboardNPS, setDashboardNPS] = useState("");
  const [dashboardAtRiskStableCustomer, setDashboardAtRiskStableCustomer] =
    useState("");
  const [dashboardAtRiskLCustomer, setDashboardAtRiskLCustomer] = useState("");
  const [dashboardAtRiskUCustomer, setDashboardAtRiskUCustomer] = useState("");
  const [dashboardCustomerLead, setDashboardCustomerLead] = useState("");
  const [dashboardCustomerGain, setDashboardCustomerGain] = useState("");
  const [dashboardCustomerLost, setDashboardCustomerLost] = useState("");

  const [dashboardCEM, setDashboardCEM] = useState("");
  const [dashboardSSM, setDashboardSSM] = useState("");
  const [dashboardSSCR, setDashboardSSCR] = useState("");
  const [marketCustData, setMarketCustData] = useState<any>();

  const dashboardFilterData = () => {
    if (revinvData) {
      const revInvDataFilter = GetObject(
        GetArray(revinvData).filter((item: any) => {
          return (
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
          );
        })
      );
      if (Object.keys(revInvDataFilter).length !== 0) {
        if (revInvDataFilter.ACCOUNT_GROWTH) {
          const lastIndex = revInvDataFilter.ACCOUNT_GROWTH.length
            ? revInvDataFilter.ACCOUNT_GROWTH.length - 1
            : 0;
          if (revInvDataFilter.TOTAL_ACCOUNT)
            setDashboardActiveAccount(
              WithCommas(
                revInvDataFilter.TOTAL_ACCOUNT[lastIndex]
                  ? revInvDataFilter.TOTAL_ACCOUNT[lastIndex]
                  : ""
              )
            );
          if (revInvDataFilter.ACCOUNT_GROWTH)
            setDashboardGrowthAccount(
              revInvDataFilter.ACCOUNT_GROWTH[lastIndex]
                ? revInvDataFilter.ACCOUNT_GROWTH[lastIndex]
                : ""
            );
          if (revInvDataFilter.INVOICE_COUNT)
            setDashboardTransactionInvoiceActive(
              WithCommas(
                revInvDataFilter.INVOICE_COUNT[lastIndex]
                  ? revInvDataFilter.INVOICE_COUNT[lastIndex]
                  : ""
              )
            );
          if (revInvDataFilter.INVOICE_GROWTH)
            setDashboardTransactionInvoiceGrowth(
              revInvDataFilter.INVOICE_GROWTH[lastIndex]
                ? revInvDataFilter.INVOICE_GROWTH[lastIndex]
                : ""
            );
          if (revInvDataFilter.TOTAL_REVENUE)
            setDashboardRevenueActiveAccount(
              WithCommas(
                revInvDataFilter.TOTAL_REVENUE[lastIndex]
                  ? revInvDataFilter.TOTAL_REVENUE[lastIndex]
                  : ""
              )
            );
          if (revInvDataFilter.REVENUE_GROWTH)
            setDashboardRevenueAccountGrowth(
              revInvDataFilter.REVENUE_GROWTH[lastIndex]
                ? revInvDataFilter.REVENUE_GROWTH[lastIndex]
                : ""
            );
          if (revInvDataFilter.retention_3m_avg)
            setDashboardRetentionRate(
              revInvDataFilter.retention_3m_avg[lastIndex]
                ? Number(revInvDataFilter.retention_3m_avg[lastIndex]).toFixed(
                    1
                  )
                : ""
            );
        }
      } else {
        setDashboardActiveAccount("-");
        setDashboardGrowthAccount("-");
        setDashboardTransactionInvoiceActive("-");
        setDashboardTransactionInvoiceGrowth("-");
        setDashboardRevenueActiveAccount("-");
        setDashboardRevenueAccountGrowth("-");
      }
    }
    if (forecastData) {
      const forecastDataFilter = GetObject(
        GetArray(forecastData).filter((item: any) => {
          return (
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
          );
        })
      );
      if (Object.keys(forecastDataFilter).length !== 0) {
        if (forecastDataFilter.forecast_12_freq) {
          const freq_12_last_idx = forecastDataFilter.forecast_12_freq.length
            ? forecastDataFilter.forecast_12_freq.length - 1
            : 0;
          if (forecastDataFilter.forecast_12_freq)
            setDashboardForecastInvoiceActive(
              WithCommas(
                forecastDataFilter.forecast_12_freq[freq_12_last_idx]
                  ? forecastDataFilter.forecast_12_freq[freq_12_last_idx]
                  : ""
              )
            );
        }
        if (forecastDataFilter.freq_growth) {
          const freq_grth_last_idx = forecastDataFilter.freq_growth.length
            ? forecastDataFilter.freq_growth.length - 1
            : 0;
          if (forecastDataFilter.freq_growth)
            setDashboardForecastInvoiceGrowth(
              forecastDataFilter.freq_growth[freq_grth_last_idx]
                ? forecastDataFilter.freq_growth[freq_grth_last_idx]
                : ""
            );
        }
        if (forecastDataFilter.forecast_12_acc)
          setDashboardForecastActiveAccount(
            WithCommas(
              forecastDataFilter.forecast_12_acc[23]
                ? forecastDataFilter.forecast_12_acc[23]
                : ""
            )
          );
        if (forecastDataFilter.acc_growth)
          setDashboardForecastGrowthAccount(
            forecastDataFilter.acc_growth[23]
              ? forecastDataFilter.acc_growth[23]
              : ""
          );

        if (forecastDataFilter.forecast_12_rev)
          setDashboardForecastRevenue(
            WithCommas(
              forecastDataFilter.forecast_12_rev[23]
                ? forecastDataFilter.forecast_12_rev[23]
                : ""
            )
          );
        if (forecastDataFilter.rev_growth)
          setDashboardForecastRevenueGrowth(
            forecastDataFilter.rev_growth[23]
              ? forecastDataFilter.rev_growth[23]
              : ""
          );
      } else {
        setDashboardForecastActiveAccount("-");
        setDashboardForecastGrowthAccount("-");
        setDashboardForecastInvoiceActive("-");
        setDashboardForecastInvoiceGrowth("-");
        setDashboardForecastRevenue("-");
        setDashboardForecastRevenueGrowth("-");
      }
    }
    if (purchaseTagRawData) {
      const purchasetagRawDataFilter = GetObject(
        GetArray(purchaseTagRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );
      if (Object.keys(purchasetagRawDataFilter).length !== 0) {
        if (purchasetagRawDataFilter.ACCOUNT_PERCENT)
          setDashboardCustomerPurchase(
            purchasetagRawDataFilter.ACCOUNT_PERCENT[0]
              ? Number(purchasetagRawDataFilter.ACCOUNT_PERCENT[0]).toFixed(1)
              : ""
          );
      } else {
        setDashboardCustomerPurchase("-");
      }
    }
    if (purchaseFreqRawData) {
      const purchasefreqRawDataFilter = GetObject(
        GetArray(purchaseFreqRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );
      if (Object.keys(purchasefreqRawDataFilter).length !== 0) {
        if (purchasefreqRawDataFilter.cust_freq)
          setDashboardCustomerFrquency(
            purchasefreqRawDataFilter.cust_freq[0]
              ? Number(purchasefreqRawDataFilter.cust_freq[0]).toFixed(1)
              : ""
          );
      } else {
        setDashboardCustomerFrquency("-");
      }
    }

    if (wsr12RawData) {
      const wsr12RawDataFilter = GetObject(
        GetArray(wsr12RawData).filter(
          (item: any) => item.BRANCH === selectedBranch.value
        )
      );
      const nps_last_idx =
        wsr12RawDataFilter?.wsr_3m && wsr12RawDataFilter?.wsr_3m.length > 0
          ? wsr12RawDataFilter?.wsr_3m.length - 1
          : 0;

      if (wsr12RawDataFilter.wsr_3m)
        setDashboardNPS(
          wsr12RawDataFilter.wsr_3m[nps_last_idx]
            ? wsr12RawDataFilter?.wsr_3m?.[nps_last_idx]
            : ""
        );
    } else {
      setDashboardNPS("-");
    }
    if (atRiskData) {
      const atRiskDataFilter = GetObject(
        GetArray(atRiskData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );
      if (Object.keys(atRiskDataFilter).length !== 0) {
        if (atRiskDataFilter.CUST_FREQ) {
          setDashboardAtRiskStableCustomer(
            atRiskDataFilter.CUST_FREQ[2]
              ? Number(atRiskDataFilter.CUST_FREQ[2]).toFixed(1)
              : ""
          );
          setDashboardAtRiskLCustomer(
            atRiskDataFilter.CUST_FREQ[0]
              ? Number(atRiskDataFilter.CUST_FREQ[0]).toFixed(1)
              : ""
          );
          setDashboardAtRiskUCustomer(
            atRiskDataFilter.CUST_FREQ[1]
              ? Number(atRiskDataFilter.CUST_FREQ[1]).toFixed(1)
              : ""
          );
        }
      } else {
        setDashboardAtRiskStableCustomer("-");
        setDashboardAtRiskLCustomer("-");
        setDashboardAtRiskUCustomer("-");
      }
    }
    if (leadRawData) {
      const lprCustLeadsFilter = GetObject(
        GetArray(leadRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );
      if (Object.keys(lprCustLeadsFilter).length !== 0) {
        setDashboardCustomerLead(
          WithCommas(
            lprCustLeadsFilter.cust_lead[0]
              ? lprCustLeadsFilter.cust_lead[0]
              : ""
          )
        );
      } else {
        setDashboardCustomerLead("-");
      }
    }
    if (gainRawData) {
      const lprCustGainFilter = GetObject(
        GetArray(gainRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );
      if (Object.keys(lprCustGainFilter).length !== 0) {
        setDashboardCustomerGain(
          WithCommas(
            lprCustGainFilter.cust_lead[0] ? lprCustGainFilter.cust_lead[0] : ""
          )
        );
      } else {
        setDashboardCustomerGain("-");
      }
    }
    if (lostRawData) {
      const lprCustLostFilter = GetObject(
        GetArray(lostRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.PRODUCT_TYPE_ALL === selectedDepartment.value
        )
      );
      if (Object.keys(lprCustLostFilter).length !== 0) {
        setDashboardCustomerLost(
          WithCommas(
            lprCustLostFilter.cust_lead[0] ? lprCustLostFilter.cust_lead[0] : ""
          )
        );
      } else {
        setDashboardCustomerLost("-");
      }
    }
    if (benchRawData) {
      const benchRawDataFilter = GetObject(
        GetArray(benchRawData).filter(
          (item: any) =>
            item.BRANCH === selectedBranch.value &&
            item.dealer_type === "all" &&
            item.key_metric === "Email %"
        )
      );

      if (benchRawDataFilter.client_perf) {
        setDashboardCEM(
          benchRawDataFilter.client_perf
            ? Number(benchRawDataFilter.client_perf).toFixed(1)
            : ""
        );
      } else {
        setDashboardCEM("-");
      }
    }
    if (sseRawData) {
      const ssFilter = GetObject(
        GetArray(sseRawData).filter(
          (item: any) => item.EMAIL_TYPE === "General-Active"
        )
      );

      if (Object.keys(ssFilter).length !== 0) {
        setDashboardSSM(
          ssFilter.CLICK_RATE
            ? Number(
                ssFilter.CLICK_RATE[ssFilter.CLICK_RATE.length - 1]
              ).toFixed(1)
            : ""
        );
        setDashboardSSCR(
          ssFilter.OPEN_RATE
            ? Number(
                ssFilter.OPEN_RATE[ssFilter.OPEN_RATE.length - 1]
              ).toFixed(1)
            : ""
        );
      } else {
        setDashboardSSM("-");
        setDashboardSSCR("-");
      }
    }
    // if (sseSumRawData) {
    //   setDashboardSSCR(
    //     sseSumRawData.ss_m ? Number(sseSumRawData.ss_m).toFixed(1) : ""
    //   );
    // } else {
    //   setDashboardSSCR("-");
    // }
    if (marketCustRawData) {
      const tempMarketCustData = marketCustRawData?.[selectedBranch.value]?.[
        selectedDepartment.value
      ]?.["12 months"]
        ? marketCustRawData?.[selectedBranch.value]?.[
            selectedDepartment.value
          ]?.["12 months"]
        : [];

      tempMarketCustData.forEach((element: any) => {
        if (element.Programs === "With Email") {
          setMarketCustData(WithCommas(element["Change From Not Program"]));
        }
      });
    }
  };

  useEffect(() => {
    if (revinvData) dashboardFilterData();
  }, [
    forecastData,
    revinvData,
    selectedBranch,
    selectedDepartment,
    purchaseTagRawData,
    purchaseFreqRawData,
    wsr12RawData,
    atRiskData,
    leadRawData,
    lostRawData,
    gainRawData,
    benchRawData,
    sseRawData,
    sseSumRawData,
  ]);


  return (
    <Grid>
      <Grid
        container
        sx={{
          padding: "0px 20px 10px 20px",
        }}
      >
        <Grid container sx={{}}>
          <Grid container item xs={4} sx={{ padding: "10px" }}>
            <SectionCard title="Active Accounts 12 Months Rolling" onHeaderClick={() => handleNavigation("growthForecast")}>
            {activeAccountLoading ? (
              <Grid
                sx={{
                          width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "200px",
                          flexBasis: "200px",
                  border: tokens.cardChrome.bodyBorder,
                }}
              >
                <MiniSpinner />
              </Grid>
            ) : (
              <Grid
                container
                item
                xs={12}
                sx={{
                  padding: "10px 20px 10px 20px",
                  border: tokens.cardChrome.bodyBorder,
                  backgroundColor: tokens.tile.bodyTint,
                  gap: 2,
                }}
              >
                <StatTile
                  orientation="row"
                  size="sm"
                  bg={tokens.cardChrome.bodyBg}
                  iconBg={tokens.tile.chipBlueBg}
                  icon={
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: `url(${graph})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        color: tokens.tile.onAccent,
                        height: "60px",
                        width: "60px",
                      }}
                    ></Grid>
                  }
                  value={dashboardActiveAccount}
                  label="Current"
                  delta={Number(dashboardGrowthAccount)}
                />
                <StatTile
                  orientation="row"
                  size="sm"
                  bg={tokens.cardChrome.bodyBg}
                  iconBg={tokens.tile.chipAmberBg}
                  icon={
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: `url(${chart})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        height: "60px",
                        width: "60px",
                      }}
                    ></Grid>
                  }
                  value={dashboardForecastActiveAccount}
                  label="Forecast"
                  delta={Number(dashboardForecastGrowthAccount)}
                />
              </Grid>
            )}
            </SectionCard>
          </Grid>
          <Grid container item xs={4} sx={{ padding: "10px" }}>
            <SectionCard title="Transactions 12 Months Rolling" onHeaderClick={() => handleNavigation("growthForecast")}>
            {activeAccountLoading ? (
              <Grid
                sx={{
                          width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "200px",
                          flexBasis: "200px",
                  border: tokens.cardChrome.bodyBorder,
                }}
              >
                <MiniSpinner />
              </Grid>
            ) : (
              <Grid
                container
                item
                xs={12}
                sx={{
                  padding: "10px 20px 10px 20px",
                  border: tokens.cardChrome.bodyBorder,
                  backgroundColor: tokens.tile.bodyTint,
                  gap: 2,
                }}
              >
                <StatTile
                  orientation="row"
                  size="sm"
                  bg={tokens.cardChrome.bodyBg}
                  iconBg={tokens.tile.chipBlueBg}
                  icon={
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: `url(${graph})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        color: tokens.tile.onAccent,
                        height: "60px",
                        width: "60px",
                      }}
                    ></Grid>
                  }
                  value={dashboardTransactionInvoiceActive}
                  label="Current"
                  delta={Number(dashboardTransactionInvoiceGrowth)}
                />
                <StatTile
                  orientation="row"
                  size="sm"
                  bg={tokens.cardChrome.bodyBg}
                  iconBg={tokens.tile.chipAmberBg}
                  icon={
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: `url(${chart})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        height: "60px",
                        width: "60px",
                      }}
                    ></Grid>
                  }
                  value={dashboardForecastInvoiceActive}
                  label="Forecast"
                  delta={Number(dashboardForecastInvoiceGrowth)}
                />
              </Grid>
            )}
            </SectionCard>
          </Grid>
          <Grid container item xs={4} sx={{ padding: "10px" }}>
            <SectionCard title="Revenue 12 Months Rolling" onHeaderClick={() => handleNavigation("growthForecast")}>
            {activeAccountLoading ? (
              <Grid
                sx={{
                          width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "200px",
                          flexBasis: "200px",
                  border: tokens.cardChrome.bodyBorder,
                }}
              >
                <MiniSpinner />
              </Grid>
            ) : (
              <Grid
                container
                item
                xs={12}
                sx={{
                  padding: "10px 20px 10px 20px",
                  border: tokens.cardChrome.bodyBorder,
                  backgroundColor: tokens.tile.bodyTint,
                  gap: 2,
                }}
              >
                <StatTile
                  orientation="row"
                  size="sm"
                  bg={tokens.cardChrome.bodyBg}
                  iconBg={tokens.tile.chipBlueBg}
                  icon={
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: `url(${graph})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        color: tokens.tile.onAccent,
                        height: "60px",
                        width: "60px",
                      }}
                    ></Grid>
                  }
                  value={<>$ {dashboardRevenueActiveAccount}</>}
                  label="Current"
                  delta={Number(dashboardRevenueAccountGrowth)}
                />
                <StatTile
                  orientation="row"
                  size="sm"
                  bg={tokens.cardChrome.bodyBg}
                  iconBg={tokens.tile.chipAmberBg}
                  icon={
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        backgroundImage: `url(${chart})`,
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        height: "60px",
                        width: "60px",
                      }}
                    ></Grid>
                  }
                  value={<>$ {dashboardForecastRevenue}</>}
                  label="Forecast"
                  delta={Number(dashboardForecastRevenueGrowth)}
                />
              </Grid>
            )}
            </SectionCard>
          </Grid>
        </Grid>
        <Grid container>
          <Grid container item xs={4} sx={{ padding: "10px" }}>
            <Grid
              container
              item
              xs={7}
              sx={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: tokens.color.primary,
                gap: 3,
                borderRadius: "10px",
                padding: "10px",
                cursor: "pointer",
                "&:hover": {
                  border: `2px solid ${tokens.tile.accentGreenBg}`,
                  cursor: "pointer",
                },
              }}
              onClick={() => {
                handleNavigation("transactions");
              }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: 3,
                }}
              >
                <Grid
                  container
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundImage: `url(${purchase})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    color: tokens.tile.onAccent,
                    height: "60px",
                    width: "60px",
                  }}
                ></Grid>
                <Typography
                  variant="h5"
                  sx={{ color: tokens.tile.onAccentMuted }}
                >
                  PURCHASE
                </Typography>
              </Grid>
              {purchaseDistributionLoading ? (
                <Grid
                  sx={{
                          width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100px",
                          flexBasis: "100px",
                  }}
                >
                  <MiniSpinner />
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", color: tokens.chart.series.invoice }}
                  >
                    {dashboardCustomerPurchase}%
                  </Typography>
                  <Typography sx={{ color: tokens.tile.onAccentMuted }}>
                    Customer purchase in
                  </Typography>
                  <Typography sx={{ color: tokens.tile.onAccentMuted }}>
                    PAST 4 WEEKS
                  </Typography>
                </Grid>
              )}
              {purchaseDistributionLoading ? (
                <Grid
                  sx={{
                          width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100px",
                          flexBasis: "100px",
                  }}
                >
                  <MiniSpinner />
                </Grid>
              ) : (
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: "bold", color: tokens.chart.series.invoice }}
                  >
                    {dashboardCustomerFrquency}%
                  </Typography>
                  <Typography sx={{ color: tokens.tile.onAccentMuted }}>
                    Customer purchase
                  </Typography>
                  <Typography sx={{ color: tokens.tile.onAccentMuted }}>
                    MORE THAN 5X
                  </Typography>
                </Grid>
              )}
            </Grid>
            <Grid
              container
              item
              xs={5}
              sx={{
                gap: 2,
                paddingLeft: "10px",
              }}
            >
              <StatTile
                accent
                bg={tokens.tile.accentGreenBg}
                icon={
                  <Grid
                    container
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundImage: `url(${twohands})`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      color: tokens.tile.onAccent,
                      height: "60px",
                      width: "60px",
                    }}
                  ></Grid>
                }
                eyebrow="RETENTION"
                value={<>{dashboardRetentionRate}%</>}
                caption="3 month average"
                loading={retentionRateLoading}
                onClick={() => {
                  handleNavigation("growthForecast");
                }}
              />
              <StatTile
                accent
                bg={tokens.tile.accentOrangeBg}
                icon={
                  <Grid
                    container
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundImage: `url(${npsscore})`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      color: tokens.tile.onAccent,
                      height: "60px",
                      width: "60px",
                    }}
                  ></Grid>
                }
                eyebrow="NPS SCORE"
                value={dashboardNPS}
                caption="3 month average"
                loading={npsScoreLoading}
                onClick={() => {
                  handleNavigation("growthForecast");
                }}
              />
            </Grid>
          </Grid>
          <Grid container item xs={8}>
            <Grid
              container
              item
              xs={4}
              sx={{
                padding: "10px",
                cursor: "pointer",
                "&:hover": {
                  border: `2px solid ${tokens.color.primary}`,
                },
              }}
              onClick={() => {
                handleNavigation("growthForecast");
              }}
            >
              <Grid
                container
                sx={{
                  padding: "10px",
                  gap: 1,
                  backgroundColor: tokens.cardChrome.bodyBg,
                  borderRadius: "10px",
                }}
              >
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    alignItems: "center",
                  }}
                >
                  <Grid
                    container
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      backgroundImage: `url(${error})`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      color: tokens.tile.onAccent,
                      height: "50px",
                      width: "50px",
                    }}
                  ></Grid>
                  <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                    At Risk
                  </Typography>
                </Grid>
                <StatTile
                  orientation="row"
                  accent
                  bg={tokens.tile.accentGreenAltBg}
                  icon={
                    <IconButton
                      sx={{ backgroundColor: tokens.tile.chipOnAccentBg }}
                      size="large"
                    >
                      <PercentIcon sx={{ color: tokens.tile.onAccent }} />
                    </IconButton>
                  }
                  value={<>{dashboardAtRiskStableCustomer}%</>}
                  label="stable"
                  loading={atRiskLoading}
                />
                <StatTile
                  orientation="row"
                  accent
                  bg={tokens.color.primary}
                  icon={
                    <IconButton
                      sx={{ backgroundColor: tokens.tile.chipOnAccentBg }}
                      size="large"
                    >
                      <PercentIcon sx={{ color: tokens.tile.onAccent }} />
                    </IconButton>
                  }
                  value={<>{dashboardAtRiskLCustomer}%</>}
                  label="Risk1"
                  valueColor={tokens.tile.statNegative}
                  loading={atRiskLoading}
                />
                <StatTile
                  orientation="row"
                  accent
                  bg={tokens.color.primary}
                  icon={
                    <IconButton
                      sx={{ backgroundColor: tokens.tile.chipNegativeBg }}
                      size="large"
                    >
                      <PercentIcon sx={{ color: tokens.tile.statNegative }} />
                    </IconButton>
                  }
                  value={<>{dashboardAtRiskUCustomer}%</>}
                  label="Risk2"
                  valueColor={tokens.tile.statNegative}
                  loading={atRiskLoading}
                />
              </Grid>
            </Grid>
            <Grid container item xs={4} sx={{ padding: "10px" }}>
              <SectionCard title="Retention Leads" headerBg={tokens.color.primary} onHeaderClick={() => handleNavigation("salesmarketing")}>
                <Grid
                  container
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    padding: "10px 20px 10px 20px",
                    border: tokens.cardChrome.bodyBorder,
                    backgroundColor: tokens.tile.bodyTint,
                    gap: 3,
                  }}
                >
                  <StatTile
                    orientation="row"
                    size="sm"
                    bg={tokens.cardChrome.bodyBg}
                    label="9-12:"
                    value={dashboardCustomerLead}
                    loading={retentionLoading}
                  />
                  <StatTile
                    orientation="row"
                    size="sm"
                    bg={tokens.cardChrome.bodyBg}
                    label="Lost:"
                    value={dashboardCustomerLost}
                    loading={retentionLoading}
                  />
                  <StatTile
                    orientation="row"
                    size="sm"
                    bg={tokens.cardChrome.bodyBg}
                    label="Gain:"
                    value={dashboardCustomerGain}
                    loading={retentionLoading}
                  />
                </Grid>
              </SectionCard>
            </Grid>
            <Grid container item xs={4} sx={{ padding: "10px" }}>
              <SectionCard title="Emails Report" headerBg={tokens.color.primary} onHeaderClick={() => handleNavigation("salesmarketing")}>
                <Grid
                  container
                  item
                  xs={12}
                  sx={{
                    padding: "10px 20px 10px 20px",
                    border: tokens.cardChrome.bodyBorder,
                    backgroundColor: tokens.tile.bodyTint,
                    gap: 2,
                  }}
                >
                  <StatTile
                    orientation="row"
                    size="sm"
                    bg={tokens.cardChrome.bodyBg}
                    label="Customer Email %:"
                    value={<>{dashboardCEM}%</>}
                    loading={emailReportsLoading}
                  />
                  <StatTile
                    orientation="row"
                    size="sm"
                    bg={tokens.cardChrome.bodyBg}
                    label="Email Value:"
                    value={marketCustData}
                    loading={emailReportsLoading}
                  />
                  <StatTile
                    orientation="row"
                    size="sm"
                    bg={tokens.cardChrome.bodyBg}
                    label="Open Rate:"
                    value={<>{dashboardSSCR}%</>}
                    loading={emailReportsLoading}
                  />
                  <StatTile
                    orientation="row"
                    size="sm"
                    bg={tokens.cardChrome.bodyBg}
                    label="Click Rate:"
                    value={<>{dashboardSSM}%</>}
                    loading={emailReportsLoading}
                  />
                </Grid>
              </SectionCard>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AnalyticDashboard;
